import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isDefinedNotEmpty, Store } from '@softline/core';
import { SOFTLINE_FEATURE_MDE_ETIKETTENDRUCK } from '../etikettendruck.shared';
import { EtikettendruckStore } from '../store/etikettendruckStore';

export const etikettendruckGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const store = inject(Store);

  if (state.url.startsWith('/mde-etikettendruck/auswahl')) return true;

  const art = store.get(
    SOFTLINE_FEATURE_MDE_ETIKETTENDRUCK,
    EtikettendruckStore.getters.art
  );

  if (!isDefinedNotEmpty(art)) {
    return router.createUrlTree(['/mde-etikettendruck/auswahl'], {
      queryParams: route.queryParams,
    });
  }
  return true;
};
